export default __webpack_public_path__ + "static/media/nmig_assist.dce54748.svg";